import { Skeleton } from '@faceup/ui-base'
import { ContentLayout } from './ContentLayout'

export const PageContentSkeleton = () => (
  <ContentLayout header={<Skeleton className='p-6' />}>
    <Skeleton className='p-5' />
  </ContentLayout>
)
